import { api, getData, patchData, postData, putData } from './request';
import type { PositionSummary } from '@cutr/constants/order';
import type {
  Position,
  PositionCreateData,
  PositionUpdateData,
  PositionDuplicateData,
  PositionMoveFileSingleData,
  PositionMoveFilesBulkData,
  PositionsBulkCreateData,
} from '@cutr/constants/position';

export function getPositionsForVariant(
  variantId: string,
  signal?: AbortSignal
) {
  return getData<Position[]>(`/v2/order-variants/${variantId}/positions`, {
    signal,
  });
}

export function getSummaryByPosition(variantId: string, signal?: AbortSignal) {
  return getData<PositionSummary[]>(
    `/v2/order-variants/${variantId}/summary-by-position`,
    { signal }
  );
}

export function createPosition(payload: PositionCreateData) {
  return postData<Position>(
    `/v2/order-variants/${payload.orderVariantId}/positions`,
    payload
  );
}

export function updatePosition(id: string, payload: PositionUpdateData) {
  return patchData<Position>(`/v2/positions/${id}`, payload);
}

export function duplicatePosition(id: string, payload: PositionDuplicateData) {
  return postData<Position>(`/v2/positions/${id}/duplicate`, payload);
}

export function sortPositions(positionIds: string[]) {
  return putData<Position[]>('/v2/positions/reorder', { positionIds });
}

export function moveFileSingleToPosition(
  id: string,
  payload: PositionMoveFileSingleData
) {
  return postData<Position>(`/v2/positions/${id}/move-file`, payload);
}

export function bulkCreatePositions(payload: PositionsBulkCreateData) {
  return postData<Position[]>(
    `/v2/order-variants/${payload.orderVariantId}/positions/bulk`,
    payload
  );
}

export async function deletePosition(id: string): Promise<void> {
  await api.delete(`/v2/positions/${id}`);
}

export async function moveFilesBulkToPosition(
  payload: PositionMoveFilesBulkData
) {
  await api.post('/v2/positions/bulk-move-files', payload);
}

export async function getArchivedPositionsForVariant(
  variantId: string,
  signal?: AbortSignal
) {
  return getData<Position[]>(
    `/v2/order-variants/${variantId}/positions/archived`,
    { signal }
  );
}

export function restorePosition(id: string) {
  return postData<Position>(`/v2/positions/${id}/restore`);
}
